var DefaultFieldValueConverter = /** @class */ (function () {
    function DefaultFieldValueConverter() {
    }
    DefaultFieldValueConverter.prototype.convertToString = function (value) {
        return String(value);
    };
    DefaultFieldValueConverter.prototype.convertToValue = function (value) {
        if (isNaN(Number(value)))
            return value;
        return Number(value);
    };
    return DefaultFieldValueConverter;
}());
var BooleanFieldValueConverter = /** @class */ (function () {
    function BooleanFieldValueConverter() {
    }
    BooleanFieldValueConverter.prototype.convertToString = function (value) {
        return value ? '1' : '0';
    };
    BooleanFieldValueConverter.prototype.convertToValue = function (value) {
        return value === '1';
    };
    return BooleanFieldValueConverter;
}());
export var fieldConverters = {
    default: new DefaultFieldValueConverter(),
    boolean: new BooleanFieldValueConverter(),
};
